export const sliderInitialData = [
    {
        user: {
            photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi2.png?alt=media&token=d825c4e5-e20d-423a-be10-0962041250f7',
            name: 'Boz Zou',
            phraze: 'UVMask'
        },
        text: "CrossProm is an easy-to-use platform that greatly simplified the cross-promotion process for us so we can focus on growing our campaign. Thanks to it and the team’s support, we kept raising thousands of dollars per update as all 3 spots were easily filled every time."
    },
    {
        user: {
            photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fecommerce%2Fecommerse-user.jpg?alt=media&token=d1c5ab5f-c1ae-401c-b236-4891ac5303b4',
            name: 'Katie Russell',
            phraze: 'Cozy Earth'
        },
        text: 'Cross promotion has proven time and time again for Cozy Earth how successful of a marketing channel it can be. Not only do we get to work with other brands we love and recommend great products and services to our customers, but we love to use cross promotion to create solutions that are mutually beneficial. Cozy Earth and the other brands we have worked with have seen a lift in page traffic, conversions, and brand awareness from just about every cross-promotion campaign run. Working together as brands is a great way to build community, as well as success.'
    },
    {
        user: {
            photo: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fcommunity%2Fi3.png?alt=media&token=3ee57422-73a0-4704-b5c2-9fff0f60debd',
            name: 'Sandy Stinson',
            phraze: 'PooPail'
        },
        text: "CrossProm helped me bring a big new wave of backers to my campaign! They really made collaboration with other campaigners easy... I can't imagine how much time it would have taken me to contact each campaign individually."
    },
]

export const swiperOptionTop = {
    loop: true,
    loopedSlides: 3, // looped slides should be the same
    spaceBetween: 10,
    slidesPerView: 1,
    allowSlideNext: false,
    allowSlidePrev: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
}
export const swiperOptionJoinedShops = {
    autoplay: true,
    slidesPerView: 3,
    spaceBetween: 10,
    clickedSlide: true,
    breakpoints: {
        1124: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 5
        },
        670: {
            slidesPerView: 1,
            spaceBetween: 100
        }
    },
    loop:true,
    // loopedSlides: 4,
    navigation: {
      nextEl: '.joined-shops__slider-arrow-next',
      prevEl: '.joined-shops__slider-arrow-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
}
export const swiperOptionThumbs =  {
    loop: true,
    loopedSlides: 3, // looped slides should be the same
    centeredSlides: true,
    slidesPerView: 3,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    navigation: {
        nextEl: ".swiper-button-custom-next",
        prevEl: ".swiper-button-custom-prev"
    }
}